
export const canvas = document.querySelector("canvas.webgl");

export const cSSGLTFLoader = document.querySelector(".loader");



